// extracted by mini-css-extract-plugin
export var aiChatCartContainer = "_ks-2";
export var aiChatCartContainerExit = "_ks-4";
export var aiChatContainerLarge = "_ks-0";
export var aiChatContainerSmall = "_ks-1";
export var aiChatIcon = "_ks-6";
export var slideInFromRight = "_ks-3";
export var slideOutToRight = "_ks-5";